import React from "react";
import { Helmet } from "react-helmet-async";
import { Container, Row, Col, Card } from "react-bootstrap";
import { Clock } from "lucide-react";
import "./ProjectsPage.css";

const ProjectsPage = () => (
    <div className="projects-page">
        <Helmet>
            <title>Projekt</title>
        </Helmet>
        
        <div className="coming-soon-section" style={{padding: '40px'}}>
            <Container>
                <Row className="justify-content-center">
                    <Col lg={10}>
                        <Card className="coming-soon-card">
                            <Card.Body className="text-center">
                                <Clock size={48} className="coming-soon-icon mb-4" />
                                <h2 className="coming-soon-title">Kommande funktion</h2>
                                <p className="coming-soon-description">
                                    Vi arbetar för fullt med att utveckla denna funktion.
                                </p>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
            </Container>
        </div>
    </div>
);

export default ProjectsPage;
